module.exports = __webpack_public_path__ + "1f5d0a512968eb2627db8670baa31f72.svg";